const NotFound: React.FC = () => {
    return (
        <div className="notFound">
            <h1 style={{marginTop: "50px", textAlign: "center"}} className="title">Page not found :(</h1>
        </div>
    )
}

export default NotFound;